import contacts from 'src/constants/columns/contacts';
import invoices from 'src/constants/columns/invoices';
import payments from 'src/constants/columns/payments';
import subscriptions from 'src/constants/columns/subscriptions';
import invoicesContact from 'src/constants/columns/invoicesContact';
import fundraising from 'src/constants/columns/fundraising';
import paymentsForInvoice from 'src/constants/columns/paymentsForInvoice';
import invoicesForPayment from 'src/constants/columns/invoicesForPayment';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import fundraisingTransactions from './fundraisingTransaction';
import tickets from './tickets';

const DEFAULT_COLUMNS = {
  contacts,
  invoices,
  invoicesContact,
  payments,
  [ENTITIES.subscriptions]: subscriptions,
  [ENTITIES.fundraisings]: fundraising,
  [ENTITIES.fundraisingTransactions]: fundraisingTransactions,
  [ENTITIES.tickets]: tickets,
  paymentsForInvoice,
  invoicesForPayment,
};

export default DEFAULT_COLUMNS;
